<!--  -->
<template>
  <div class="guide-tool-btn">
    <div
      :class="['img-wrap', show ? 'show-1' : 'hide-1']"
      @click.stop="toGuide"
    >
      <img :src="showUrl" alt="" />

      <span class="label">新手指引</span>

      <span class="to-hide" @click.stop="display(false)">×</span>
    </div>
    <div
      class="hide-wrap"
      :class="['img-wrap', !show ? 'show-2' : 'hide-2']"
      @click.stop="display(true)"
    >
      <img :src="hideUrl" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'gudie-tool',
  components: {},
  props: {
    path: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      basePath: '/guide/document',
      show: true,
      showUrl: require('../../../public/images/guide-btn-1.png'),
      hideUrl: require('../../../public/images/guide-btn-2.png'),
    }
  },
  computed: {
    url() {
      return `${this.basePath}#${this.path}`
    },
  },
  watch: {},
  created() {},

  mounted() {},
  methods: {
    display(bool) {
      this.show = bool
    },
    toGuide() {
      let routeUrl = this.$router.resolve({
        path: this.url,
      })
      window.open(routeUrl.href, '_blank')
    },
  },
  updated() {},
  beforeDestroy() {},
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@keyframes hide1 {
  0% {
    transform: translateX(0px);
    opacity: 1;
  }
  100% {
    transform: translateX(30px);
    opacity: 0;
  }
}
@keyframes show1 {
  0% {
    transform: translateX(15px);
  }
  100% {
    transform: translateX(0);
  }
}

.guide-tool-btn {
  .img-wrap {
    position: fixed;
    right: 0px;
    bottom: 50px;
    z-index: 99;
    cursor: pointer;
    &.show-1 {
      display: block;
      opacity: 1;
      animation: show1 0.5s;
      animation-fill-mode: forwards;
    }
    &.hide-1 {
      animation: hide1 0.5s;
      animation-fill-mode: forwards;
    }
    &.show-2 {
      display: block;
    }
    &.hide-2 {
      display: none;
    }
  }

  .label {
    display: block;
    position: absolute;
    font-size: 8px;
    top: 14px;
    left: 23px;
    width: 20px;
    z-index: 10;
    color: #fff;
    transform: scale(0.9);
  }

  .to-hide {
    display: block;
    position: absolute;
    font-size: 16px;
    bottom: 18px;
    left: 23px;
    z-index: 10;
    color: #fff;
    font-size: 18px;
  }
}
</style>
